import { render, staticRenderFns } from "./PartTable.vue?vue&type=template&id=06ca933f&"
import script from "./PartTable.vue?vue&type=script&lang=ts&"
export * from "./PartTable.vue?vue&type=script&lang=ts&"
import style0 from "./PartTable.vue?vue&type=style&index=0&id=06ca933f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports